<template>
    <div>
        <e-step :stepData="stepData" :activeStep="activeStep"/>
        <tip-message :tipData="tipData"/>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="ruleForm">
            <el-form-item label="关联银行卡：" prop="serialNo">
                <el-select v-model="ruleForm.serialNo" placeholder="请选择关联银行卡">
                    <el-option
                            v-for="item in bankCardList"
                            :key="item.serialNo"
                            :label="item.bankCardNo"
                            :value="item.serialNo">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属行业：" prop="category">
                <el-select v-model="ruleForm.category" filterable  placeholder="请选择所属行业">
                    <el-option
                            v-for="item in categoryList"
                            :key="item.categoryCode"
                            :label="item.category"
                            :value="item.categoryCode">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="客服电话：" prop="servicePhone">
                <el-input v-model="ruleForm.servicePhone" placeholder="请输入客服电话" style="width: 205px"></el-input>
            </el-form-item>
        </el-form>
        <div class="flex-c">
            <el-button style="width:60px" type="primary" plain  @click="toPath">取消</el-button>
            <d-button    btnType="primary" v-on:debounceclick="saveData" btnTxt="提交"></d-button>
        </div>
    </div>
</template>

<script>
    import api from "../../../api/order";
    import payApi from "../../../api/pay";
    import { mobilePhone } from "../../../utils/validate";
    import tipMessage from './tipMessage';
    import eStep from './e-steps';
    export default {
        name: "applyForActivation",
        components:{tipMessage,eStep},
        data(){
            return{
                payWay:0,
                stepData:[
                    {title:'申请开通',},
                    {title:'商家认证',},
                ],
                activeStep:1,
                tipData:[{title:'申请后，请耐心等待(预计2天)。审核通过后，您可进行下一步商家认证操作。'}],
                bankCardList:[],//关联银行卡
                categoryList:[],//所属行业
                ruleForm: {
                    serialNo:'',
                    category:'',
                    servicePhone:'',
                },
                rules: {
                    serialNo: [{required: true, message: '请选择关联银行卡', trigger: 'change'},],
                    category: [{required: true, message: '请选择所属行业', trigger: 'change'}],
                    servicePhone: [{required: true, validator: mobilePhone, trigger: 'change'}],
                }
            }
        },
        methods:{
            toPath(){
                this.$router.push({ path: "/scanCodePayManagement" })
            },
            saveData(){
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        //判断是否开通扫码支付
                       this.openCodeCollection();
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            async openCodeCollection() {
                //判断是否开通扫码支付
                let res = await api.openCodeCollection({...this.ruleForm, payWay: this.payWay});
                if (res.code === '200') {
                    //开关标志 0、开启 1、关闭
                    this.$message.success('提交成功。')
                    this.toPath();
                 }
            },
            //查询关联银行卡
            async getBankCardList() {
                let res = await payApi.queryAvailableBankCard();
                if (res.code === "200") {
                    this.bankCardList = res.data;
                }
            },
            //扫码支付 所属行业
            async queryCpcnCcategory(){
                let res = await api.queryCpcnCcategory({payWay:this.payWay});
                if (res.code === "200") {
                    this.categoryList = res.data;
                }
            },
        },
        mounted() {
            this.payWay = Number(this.$route.query.payWay);
            this.getBankCardList();
            this.queryCpcnCcategory();
        }
    }
</script>

<style scoped lang="scss">
    .ruleForm{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
</style>